export const REQUEST_STATUSES = {
  NEW: 0,
  PENDING: 1,
  APPROVED: 2,
  REJECTED: 3,
  COMPLETED: 4,
  SUBMITTED: 5,
  RETURN: 6,
};

export const LEVELS = {
  KPI: 1,
  StrategicObjective: 2,
  Perspective: 3,
  Theme: 4,
  StrategicSubObjective: 5,
  Initiative: 6,
};

const enums = {
  REQUEST_STATUSES,
  LEVELS,
};

// pages codes
// GD - general dashboard
// TC - task center
// DE - delegation
// RE - reports
// BSC - strategy map
// CA - central admin

export default enums;
